import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      cards: [],
      subscriptions: [],
      newCard: {
        setupIntent: {
          client_secret: null
        }
      }
    };
  },
  mutations,
  actions,
  getters
};